/**
 * Breadcrumbs — local navigation (design README §3): path from portfolio to
 * the current level; the current level is the unlinked breadcrumb end; page
 * titles match the inbound link labels exactly (scent). Links carry the
 * current period (Deep-Linked State).
 */

import type { PeriodSelection } from '@domain/types'
import { branchPath, tinOfBranch, tpinPath } from '@domain/tpinPaths'
import { Link } from './Link'

export interface Crumb {
  label: string
  /** Absent = current page (unlinked end). */
  to?: string
}

export function Breadcrumbs({ crumbs, period }: { crumbs: readonly Crumb[]; period: PeriodSelection }) {
  return (
    <nav className="breadcrumbs" data-testid="breadcrumbs" aria-label="Breadcrumb">
      <ol>
        {crumbs.map((crumb, index) => (
          <li key={`${crumb.label}-${index}`}>
            {crumb.to === undefined ? (
              <span aria-current="page" data-testid="breadcrumb-current">
                {crumb.label}
              </span>
            ) : (
              <Link to={crumb.to} period={period}>
                {crumb.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}

/**
 * TPIN > Branch > {current}: the drilldown trail of a branch-scoped worklist
 * (S3 failed list, S4 pending list). The worklist's parent is the S-BRANCH view
 * of the same branch, not the retired portfolio (TL ruling 2026-10-30, A2).
 */
export function listCrumbs(dbName: string, current: string): Crumb[] {
  const tin = tinOfBranch(dbName)
  return [
    { label: `TPIN ${tin}`, to: tpinPath(tin) },
    { label: `Branch ${dbName}`, to: branchPath(tin, dbName) },
    { label: current },
  ]
}
